import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Tooltip,
} from '@material-ui/core';
import { setSpecificSpecialEventData } from '../../../redux/actions/newOperationHoursActions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
  }),
);

export default function ({ disableAll }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const {
    cateringTimeOpenMode,
    cateringTimeCloseMode,
    cateringTimeOpen,
    cateringTimeClose,
    availableTimes,
  } = useSelector((state: RootStateOrAny) => state.NewOperationHoursReducer);

  const [selectOpenSelectedIndex, setSelectOpenSelectedIndex] = useState(0);

  const disabledSelects = disableAll;

  const onChangeSelectOpen = event => {
    const select = event.target as HTMLSelectElement;
    if (cateringTimeOpen !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          cateringTimeOpen: select.value,
        }),
      );
    }
  };

  const onChangeSelectClose = event => {
    const select = event.target as HTMLSelectElement;
    if (cateringTimeClose !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          cateringTimeClose: select.value,
        }),
      );
    }
  };

  useEffect(() => {
    const index = availableTimes.findIndex(elem => elem === cateringTimeOpen);
    setSelectOpenSelectedIndex(index);
  }, [cateringTimeOpen]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={4} md={4}>
          <div className={classes.demo}>
            <List>
              <ListItem>
                <ListItemText primary={t('operationHours.cateringTime')} />
              </ListItem>
            </List>
          </div>
        </Grid>
        <Grid item xs={2} md={2}></Grid>
        <Grid item xs={3} md={3}>
          {cateringTimeOpenMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.start')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !cateringTimeOpenMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={cateringTimeOpen ? cateringTimeOpen : ''}
                  label={t('operationHours.start')}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectOpen}
                  disabled={disabledSelects || !cateringTimeOpenMode.includes('write')}
                >
                  {availableTimes?.map((elem, index) => (
                    <option key={index} value={elem}>
                      {elem}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
        <Grid item xs={3} md={3}>
          {cateringTimeCloseMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.close')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !cateringTimeCloseMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={cateringTimeClose ? cateringTimeClose : ''}
                  label={t('operationHours.close')}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectClose}
                  disabled={disabledSelects || !cateringTimeCloseMode.includes('write')}
                >
                  {availableTimes
                    ?.filter(
                      (elem, index) =>
                        index > selectOpenSelectedIndex || index === 0,
                    )
                    .map((elem, index) => (
                      <option value={elem}>{elem}</option>
                    ))}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );
}
